import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import Logo from './assets/images/logo.png';
import MaintenanceImage from './assets/images/maintenance-img.png';

export default function MaintenancePage() {
  return (
    <div>
    <Box
      sx={{
        display: 'flex',
        flex: 1,
        alignItems: 'center',
        justifyContent: 'space-evenly',
        padding: '1rem',
        textAlign: 'center',
        flexDirection: 'column',
      }}
    >
      <img src={Logo} alt='logo' width='100%' style={{ padding: '2.2rem' }} />
      <img
        src={MaintenanceImage}
        alt='maintenance'
        width='100%'
        className='maintenance-img'
      />
      <Box>
        <Typography
          component='h5'
          variant='h1'
          fontSize='1.6rem'
          fontWeight={600}
        >
          {'Be back soon!'}
        </Typography>
        <Typography
          component='h5'
          variant='body1'
          color='gray'
          fontSize='1.2rem'
          fontWeight={500}
          mt={2}
        >
          {
            'Our AI personalities are on a coffee break while we do some maintenance. Check back soon!'
          }
        </Typography>
      </Box>
    </Box>
    </div>
  );
}
